export const isMobile = (navigator: Navigator) => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
}



// WEBPACK FOOTER //
// ./src/components/generic/Helpers.ts